import React from "react";
import { RiskLevel } from "../../../../types/cdd-records.types";

export const getRiskColor = (risk: RiskLevel): string => {
  switch (risk) {
    case "low":
      return "green";
    case "medium":
      return "yellow";
    case "high":
      return "orange";
    case "critical":
      return "red";
    default:
      return "gray";
  }
};

export const RiskMeter: React.FC<{ risk: RiskLevel }> = ({ risk }) => {
  const levels = ["low", "medium", "high", "critical"];
  const currentIndex = levels.indexOf(risk);

  return (
    <div className="flex items-center gap-1">
      {levels.map((level, index) => (
        <div
          key={level}
          className={`h-2 w-8 rounded ${
            index <= currentIndex
              ? `bg-${getRiskColor(risk as RiskLevel)}-500`
              : "bg-gray-200"
          }`}
          title={level}
        />
      ))}
    </div>
  );
};
